import { Box, Stack } from "@mui/material";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useAppDispatch } from "@/app/store";
import { useAuth } from "@/shared/auth/useAuth";
import { useCognitoSignOut } from "@/shared/auth/useCognitoSignOut";
import { usePageLayout } from "@/app/routes/pageLayout";
import { LAYOUT_AVATAR_Z_INDEX, PAGE_PADDING } from "@/constants";
import { fetchCurrentUser } from "@/features/users/model/usersSlice";
import { AppSidebar } from "@/shared/ui/layout/AppSidebar";
import { PageContainer } from "@/shared/ui/layout/PageContainer";
import { SecondarySidebar } from "@/shared/ui/layout/SecondarySidebar";
import { SecondarySidebarProvider } from "@/shared/ui/layout/SecondarySidebarProvider";
import { SidebarCollapseProvider } from "@/shared/ui/layout/SidebarCollapseProvider";
import { UserAccountMenu } from "@/shared/ui/layout/UserAccountMenu";

export function MainLayout() {
  const { isAuthenticated } = useAuth();
  const dispatch = useAppDispatch();
  const signOut = useCognitoSignOut();
  const { maxWidthPx, secondarySidebar } = usePageLayout();

  useEffect(() => {
    if (!isAuthenticated) return;
    void dispatch(fetchCurrentUser());
  }, [isAuthenticated, dispatch]);

  return (
    <SidebarCollapseProvider>
    <SecondarySidebarProvider enabled={secondarySidebar}>
      <Box sx={{ display: "flex", minHeight: "100%", height: "100%" }}>
        <AppSidebar />
        <Box
          component="main"
          sx={{ flex: 1, minWidth: 0, minHeight: 0, display: "flex", flexDirection: "column" }}
        >
          <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
            <Box
              sx={{
                width: "100%",
                maxWidth: maxWidthPx,
                mx: "auto",
                minHeight: "100%",
                height: secondarySidebar ? "100%" : "auto",
                display: "flex",
                alignItems: "stretch",
                position: "relative",
              }}
            >
              {isAuthenticated ? (
                <Box
                  sx={{
                    position: "absolute",
                    top: PAGE_PADDING.DEFAULT.Y_PX,
                    right: PAGE_PADDING.DEFAULT.RIGHT_PX,
                    zIndex: LAYOUT_AVATAR_Z_INDEX,
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <UserAccountMenu onLogout={signOut} />
                  </Stack>
                </Box>
              ) : null}
              <SecondarySidebar enabled={secondarySidebar} />
              <PageContainer>
                <Outlet />
              </PageContainer>
            </Box>
          </Box>
        </Box>
      </Box>
    </SecondarySidebarProvider>
    </SidebarCollapseProvider>
  );
}
